import React, { useState } from "react";
import { db } from "../../firebase-config";
import { collection, getDocs, limit, query, startAfter, limitToLast, orderBy, endBefore } from "firebase/firestore";

import PropTypes from 'prop-types';
import styles from './PaginationListTable.module.css';

import Input from "../../Components/forms/Input";
import Loading from "../../Components/Loading";
import { FiExternalLink } from 'react-icons/fi';
import DefaultButton from "../../Components/forms/DefaultButton"

import { formatDate } from "../../utils/standaloneUtils";

const PaginationListTable = (props) => {
  const [data, setData] = useState([]);
  const [firstDocId, setFirstDocId] = useState();

  const [firstDocument, setFirstDocument] = useState();
  const [lastDocument, setLastDocument] = useState();
  const [buttonNextValidator, setButtonNextValidator] = useState(true);
  const [buttonPrevValidator, setButtonPrevValidator] = useState(true);

  const [userSearched, setUserSearched] = useState("");
  const [loading, setloading] = useState(true);

  async function getRegister() {
    try {
      setloading(false);
      const docQuery = query(collection(
        db,
        props.collection),
        orderBy(props.orderby, props.orderbyOrientation),
        limit(20),
      );
      const documents = await getDocs(docQuery);
      setFirstDocument(documents.docs[0]);
      setLastDocument(documents.docs[documents.docs.length - 1]);

      documents.forEach((doc) => {
        let objData = doc.data();
        objData.id = doc.id;
        setFirstDocId(doc.id)
        if (data.length === 0) {
          (doc.id != 'first_item')
            ? (setButtonNextValidator(true), setData((prevData) => [...prevData, objData]))
            : setButtonNextValidator(false);
        }
      });
    } catch (error) {
      console.error(error);
    } finally {
      setloading(true);
    }
  }

  async function getNextPage() {
    setloading(false);
    setData([])
    const nextQuery = query(collection(
      db,
      props.collection),
      orderBy(props.orderby, props.orderbyOrientation),
      startAfter(lastDocument),
      limit(20),
    );
    const documents = await getDocs(nextQuery);
    setFirstDocument(documents.docs[0]);
    setLastDocument(documents.docs[documents.docs.length - 1]);
    documents.forEach((doc) => {
      let objData = doc.data();
      objData.id = doc.id;
      (doc.id != 'first_item')
        ? (setButtonNextValidator(true), setData((prevData) => [...prevData, objData]))
        : setButtonNextValidator(false);
      (firstDocId == doc.id)
        ? setButtonPrevValidator(true)
        : setButtonPrevValidator(false)
      setloading(true);
    });
  }

  async function getPrevPage() {
    setloading(false);
    setData([])
    const nextQuery = query(collection(
      db,
      props.collection),
      orderBy(props.orderby, props.orderbyOrientation),
      endBefore(firstDocument),
      limitToLast(21),
    );
    const documents = await getDocs(nextQuery);
    setFirstDocument(documents.docs[0]);
    setLastDocument(documents.docs[documents.docs.length - 1]);
    documents.forEach((doc) => {
      let objData = doc.data();
      (doc.id != 'first_item')
        ? (setButtonNextValidator(true), setData((prevData) => [...prevData, objData]))
        : setButtonNextValidator(false);
      (doc.id == firstDocId)
        ? setButtonPrevValidator(true)
        : setButtonPrevValidator(false)
      setloading(true);
    });
  }

  React.useEffect(() => {
    getRegister();
  }, []);

  function handleSearchUser({ target }) {
    setUserSearched(target.value);
  }

  if (!loading) {
    return <Loading>Carregando os Registros...</Loading>;
  }

  const renderData = (data, header) => {
    if (props.translation) {
      return (data[header]?.seconds) ?
        formatDate(data[header]) :
        (header == "url") ?
          <a href={data[header]} data-tooltip={`${data[header]}`} target="_blank">
            <FiExternalLink />
          </a> :
          (Object.entries(props.translation).map(([reference, translation]) => {
            return (reference == header) ?
              ([undefined, null, ''].includes(data[header]) ? "N/A" : translation[data[header]]) :
              data[header]
          }))
    } else {
      return (data[header]?.seconds) ?
        (header == "url") ?
          <a href={data[header]} data-tooltip={`${data[header]}`} target="_blank">
            <FiExternalLink />
          </a> :
          formatDate(data[header]) :
        data[data]
    }
  }

  return (
    <main className="container">
      <div className="container-page">
        <div className={`${styles.titleAdjust}`}>
          <div>
            <img src={props.logo} className={styles.iconNav} />
            <div className={styles.headerTitle}>
              <h1> {props.tableTitle} </h1>
              <h3> {props.tableSubTitle} </h3>
            </div>
          </div>
          <div className={styles.buttonOfertas}>
            <Input
              className={styles.inputRegister}
              placeholder={props.searchKeyword}
              onChange={handleSearchUser}
              value={userSearched}
            />
          </div>
        </div>
        <section className={`${styles.sectionWebPush} container`}>
          <div className={styles.tabela}>
            <table>
              <thead>
                <tr>
                  {Object.keys(props.tableHeaders).map(
                    (header) =>
                      (<th>{header}</th>)
                  )}
                </tr>
              </thead>
              {data.filter((register) => {
                return userSearched
                  ? register.emailSended.includes(userSearched)
                  : register;
              }).map((register) => (
                <tbody key={register.id}>
                  <tr>
                    {Object.values(props.tableHeaders).map(
                      (e) => {
                        return <td>{renderData(register, e)}</td>
                      }
                    )}

                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        </section>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <DefaultButton
          type={buttonPrevValidator ? "disabled" : "red"}
          size="MD"
          onClick={() => { getPrevPage() }
          }
          children="Pagina Anterior"
        />
        <DefaultButton
          type={buttonNextValidator ? "red" : "disabled"}
          size="MD"
          onClick={() => { getNextPage() }
          }
          children="Proxima pagina"
        />
      </div>
    </main>
  )
};

PaginationListTable.propTypes = {
  collection: PropTypes.string,
  orderby: PropTypes.string,
  orderbyOrientation: PropTypes.string,
  logo: PropTypes.element,
  tableTitle: PropTypes.string,
  tableSubTitle: PropTypes.string,
  searchKeyword: PropTypes.string,
  tableHeaders: PropTypes.object,
  translation: PropTypes.object
};
PaginationListTable.defaultProps = {};

export default PaginationListTable;